'use client'

import { useEffect, useState } from 'react'
import { ActionButton } from '@/components/parts/action-button'
import { useFromParams } from '@/hooks/use-from-params'

const MOBILE_DEVICES = [
  'iphone',
  'ipad',
  'android',
  'blackberry',
  'windows phone',
  'mobile',
  'tablet'
]

type DemoActionButtonProps = {
  label?: string
  variant?: 'primary' | 'outline'
  /** 親の幅いっぱいに広げる */
  block?: boolean
  className?: string
}

/**
 * ライブデモ（/demo）へのボタン。流入元のパラメータを引き継ぐ。
 * ライブデモはデスクトップでのみ体験できるため、SP・タブレットでは何も出さない（Contact と同じ判定）
 */
export function DemoActionButton({
  label = 'ライブデモを見る',
  variant = 'outline',
  block = false,
  className
}: DemoActionButtonProps) {
  const params = useFromParams()
  const [isDesktop, setIsDesktop] = useState(false)

  useEffect(() => {
    const userAgent = window.navigator.userAgent.toLowerCase()
    setIsDesktop(!MOBILE_DEVICES.some((device) => userAgent.includes(device)))
  }, [])

  if (!isDesktop) return null

  return (
    <ActionButton
      href={`/demo/${params}`}
      label={label}
      variant={variant}
      block={block}
      className={className}
    />
  )
}
